import { useQuery } from '@tanstack/react-query'
import { getInquirySales } from '@/lib'
import { queryKeys } from '@/lib/queryKeys'

export function useInquirySales(inquiryId: number) {
  return useQuery({
    queryKey: queryKeys.inquiry.sales(inquiryId),
    queryFn: async () => {
      return getInquirySales(inquiryId)
    },
    enabled: inquiryId > 0,
  })
}
